document.addEventListener('DOMContentLoaded', function () {
  // Selecciona todos los elementos con la clase ".multi-column__item"
  var multiColumnItems = document.querySelectorAll('.multi-column__item');

  // Itera sobre cada elemento y busca las imágenes dentro de ellos
  multiColumnItems.forEach(function (item) {
    var images = item.querySelectorAll('img');

    // Itera sobre cada imagen y elimina las clases específicas
    images.forEach(function (image) {
      image.classList.remove('zoom-image');
      image.classList.remove('group-hover:zoom');
    });
  });

  // Seleccionamos el elemento #size-chart y el contenedor x-modal .prose
  const sizeChart = document.querySelector('#size-chart');
  const modalProse = document.querySelector('x-modal .prose');
  const modalProseP = document.querySelector('x-modal .prose p');

  // Ocultamos el contenido dentro de x-modal .prose
  modalProseP.style.display = 'none';

  // Movemos #size-chart al contenedor x-modal .prose
  modalProse.appendChild(sizeChart);

  // Mostramos #size-chart estableciendo su estilo display a 'block'
  sizeChart.style.display = 'block';
});

var links = document.links;
for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
  if (links[i].hostname !== window.location.hostname) {
    links[i].target = '_blank';
    links[i].rel = 'noreferrer noopener';
  }
}